export default __webpack_public_path__ + "static/media/obi.f763beef.jpg";